import { createBrowserRouter, Navigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";

import Home from "../pages/Home";
import Reservation from "../pages/Reservations";
import Career from "../pages/Careers";
import AboutUs from "../pages/AboutUs";
import OurMenu from "../pages/OurMenu";
import Intro from "../pages/Intro";
import NotFound from "../pages/NotFound";

// Admin
import AdminLogin from "../admin/AdminLogin";
import AdminLayout from "../admin/AdminLayout";
import AdminProtectedRoute from "../admin/AdminProtectedRoute";
import Dashboard from "../admin/Dashboard";
import MembersManager from "../admin/pages/MembersManager";
import ReservationManager from "../admin/pages/ReservationManager";
import CareerManager from "../admin/pages/CareerManager";
const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/intro", element: <Intro /> },
      { path: "/about-us", element: <AboutUs /> },
      { path: "/our-menu", element: <OurMenu /> },
      { path: "/reservations", element: <Reservation /> },
      { path: "/careers", element: <Career /> },
    ],
  },

  // ── Admin ──────────────────────────────────────────────────────────────────
  // /admin exactly → login page (no auth needed)
  { path: "/admin", element: <AdminLogin /> },

  // /admin/* → protected layout with nested pages
  {
    path: "/admin",
    element: (
      <AdminProtectedRoute>
        <AdminLayout />
      </AdminProtectedRoute>
    ),
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "members",
        element: <MembersManager />,
      },
      {
        path: "reservations",
        element: <ReservationManager />,
      },
      {
        path: "careers",
        element: <CareerManager />,
      },
      // Redirect /admin/anything-invalid
      {
        path: "*",
        element: <Navigate to="/admin/dashboard" replace />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
